import React, { useEffect, useRef, useState } from 'react';
import ApexCharts, { ApexOptions } from 'apexcharts';
import { getCSSVariableValue } from '../../../assets/ts/_utils';
import {
  formatWithCommas,
  formatNumber,
  calculateRemainingPercentage,
} from '../../../helpers';

type Props = {
  total: number;
  consumo: number;
  disponible: number;
};

const RadialDataGraphic: React.FC<Props> = ({ total, consumo, disponible }) => {
  const chartRef = useRef<HTMLDivElement | null>(null);

  const refreshChart = () => {
    if (!chartRef.current) {
      return;
    }

    const chart = new ApexCharts(
      chartRef.current,
      chartOptions(total, consumo)
    );
    if (chart) {
      chart.render();
    }

    return chart;
  };

  useEffect(() => {
    const chart = refreshChart();

    return () => {
      if (chart) {
        chart.destroy();
      }
    };
  }, [total, consumo]);

  return (
    <div className="card card-custom card-flush bg-opacity-0">
      <div className="card-header justify-content-center align-items-center"></div>

      <div className="card-body pt-0">
        <div className="row align-items-center">
          <div className="col-md-12 d-flex flex-column justify-content-center align-items-center position-relative">
            <div
              id="kt_card_widget_17_chart"
              ref={chartRef}
              style={{
                minWidth: '100px',
                minHeight: '100px',
                width: '170px',
                height: '150px',
              }}
            ></div>

            <div
              style={{
                position: 'absolute',
                bottom: '55px',
                left: '50%',
                transform: 'translateX(-50%) translateY(0)',
                textAlign: 'center',
              }}
            >
              <div
                style={{
                  fontSize: '12px',
                  color: '#3498db',
                  fontWeight: 'bold',
                }}
              >
                {formatWithCommas(disponible)}
              </div>
              <div
                style={{
                  fontSize: '12px',
                  color: '#3498db',
                  fontWeight: 'bold',
                }}
              >
                MB
              </div>
            </div>
          </div>

          <div className="row p-0 m-0">
            <div className="col-md-12 text-center">
              <div className="mb-1">
                <label className="fw-bolder">Adquirido</label>
                <div
                  className="fw-bold text-muted text-truncate"
                  title="32323423432422423"
                >
                  {formatWithCommas(total)}
                </div>
              </div>
              <div className="mb-1">
                <label className="fw-bolder">Consumido</label>
                <div className="fw-bold text-muted">
                  {formatWithCommas(consumo)}
                </div>
              </div>
              <div className="mb-1">
                <label className="fw-bolder">Disponible</label>
                <div className="fw-bold text-muted">
                  {formatWithCommas(disponible)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const chartOptions = (
  dataTotal: number,
  dataAbailable: number
): ApexOptions => {
  const baseColor = getCSSVariableValue('--bs-primary');
  const lightColor = '#D6FFEB';
  const labelColor = '#000';

  return {
    series: [calculateRemainingPercentage(dataTotal, dataAbailable)],
    chart: {
      // fontFamily: 'inherit',
      height: '200px',
      type: 'radialBar',
    },
    plotOptions: {
      radialBar: {
        hollow: {
          margin: 0,
          size: '60%',
        },
        dataLabels: {
          name: {
            show: true,
            fontSize: '18px',
            fontWeight: 'bolder',
            color: labelColor,
            offsetY: -10,
          },
          value: {
            show: false,
          },
        },
        track: {
          background: lightColor,
          strokeWidth: '100%',
        },
      },
    },
    colors: [baseColor],
    stroke: {
      lineCap: 'round',
    },
    labels: ['Total'],
  };
};

export { RadialDataGraphic };
